import { useState } from 'react'

import isEmpty from 'lodash/isEmpty'

import { useUnsafeAsyncData } from 'modules/core/hooks/useAsyncData'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import type Employee from 'modules/employees/store/models/Employee'
import { leaveEmployee } from 'modules/timeoff/lib/leaveEmployees'
import leaves from 'modules/timeoff/store/collections/leaves'
import Leave from 'modules/timeoff/store/models/Leave'

interface Props {
  leaveId: number
  onClose: () => void
}
interface ReturnType {
  leave: Leave
  leaveLoading: boolean
  employee: Employee | null | undefined
}

const useFetchLeave = ({ leaveId, onClose }: Props): ReturnType => {
  const [leave, setLeave] = useState(new Leave(Leave.buildNullLeave(leaveId)))
  const [employee, setEmployee] = useState<Employee | null>(null)

  const { loading: leaveLoading } = useUnsafeAsyncData(async () => {
    const model = leaves.find({
      id: leaveId,
    })

    if (model) {
      setLeave(model)
      setEmployee(leaveEmployee(model))

      return
    }

    setLeave(leave)

    const { success, value } = await asyncAction(() => leave.fetch(), {
      successFlash: false,
    })

    if (success && !isEmpty(value)) {
      leave.set(value)
      leaves.set([leave])
      setLeave(leave)
      setEmployee(leaveEmployee(leave))
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('time_off.deleted'),
      })
      onClose()
    }
  }, [leaveId, onClose])

  return {
    leaveLoading,
    leave,
    employee,
  }
}

export default useFetchLeave
